import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/settings_/locations/$locationId/')({
  component: lazyRouteComponent(() => import('&/features/settings/locations/pages/location-general-page')),
  staticData: { titleKey: 'general' },
});
